import Icon from "@material-ui/icons/Person";
import AreasCreate from "./AreasCreate";
import AreasEdit from "./AreasEdit";

export default {
  name: "areas",
  edit: AreasEdit,
  create: AreasCreate,
  icon: Icon,
};
